import { UserType } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router';

import { UserList } from '@/components/shared/components/UserList/UserList';
import { ModuleCorePermissionProps } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MerchantUserList = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  return <UserList userIds={[merchantId]} userType={UserType.MERCHANT} editModeAllowed={canEdit} />;
};

export const MerchantUserListModule = withPermissionsModule(MerchantUserList);
